module.exports = __webpack_public_path__ + "img/anquan1-4.106590fc.jpg";